import React, { useEffect, useState } from 'react';
import constants from '../../../../constants';
import { Block } from '../../../../../../components';
import {
  TextTitle,
  ToggleHeader
} from '../../../certificates-constancies/type1/register/components';
import Step from '../../UpdatePhoto/Register/components/Step';
import Spinner from '../../../../../../components/Spinner';
import {
  ButtonBack,
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import ModalConfirmation from '../../../../components/Modal/Modal';
import ConfirmAction from '../../../certificates-constancies/type1/progress/components/ConfirmAction';
import Processing from '@/presentation/components/Processing';
import ButtonCancelRequest from '../../../../../../components/ButtonCancelRequest';
import { ProcedureInfoComponent } from '../info/components/ProcedureInfoComponent';
import CardPayment from '../../Reincorporation/progress/components/CardPayment';
import CardProgress from '../../../../../../reusables/CardProgress';
import documentSuccessImage from '../../../../../../../assets/illustrations/procedures/cards/document-success.svg';
import documentSuccessDskImage from '../../../../../../../assets/illustrations/procedures/cards/document-success-dsk.svg';
import documentFailedImage from '../../../../../../../assets/illustrations/procedures/cards/document-failed.svg';
import documentFailedDskImage from '../../../../../../../assets/illustrations/procedures/cards/document-failed-dsk.svg';
import Link from '@/presentation/reusables/Link';

interface IssuanceUniversityCardProgressViewPropsProps {
  procedure: any;
  request: any;
  isLoading: boolean;
  isLoadingCancel: boolean;
  isLoadingActivatePayment: boolean;
  showAnulate: boolean;
  isSuccessActivatePayment: boolean;
  handlerCloseModal: () => void;
  handlerOkModalProgress: () => void;
  handlerShowAnulate: () => void;
  handlerBackButton: () => void;
  handlerActivatePayment: () => void;
  campus: any;
  phone: string;
  amountDelivery: any;
  deliveryMode: any;
  showActivatedPaymentModal: boolean;
  setShowActivatedPaymentModal: any;
}

const IssuanceUniversityCardProgressView = (
  props: IssuanceUniversityCardProgressViewPropsProps
) => {
  const {
    isLoading,
    request,
    procedure,
    handlerShowAnulate,
    handlerCloseModal,
    isLoadingCancel,
    handlerOkModalProgress,
    handlerBackButton,
    handlerActivatePayment,
    showAnulate,
    isLoadingActivatePayment,
    isSuccessActivatePayment,
    campus,
    phone,
    amountDelivery,
    deliveryMode,
    showActivatedPaymentModal,
    setShowActivatedPaymentModal
  } = props;
  const evalStatus = () =>
    constants.procedureStatus.issuanceCarnetCard.find(
      (s: any) => s.name === request?.status.status
    );

  const [isPaymentActive, setIsPaymentActive] = useState(false);
  const [isPaymentDone, setIsPaymentDone] = useState(false);

  useEffect(() => {
    if (request) {
      if (evalStatus()?.name === 'PAGO_ACTIVADO') {
        setIsPaymentActive(true);
      } else if (evalStatus()?.name === 'PROCEDE') {
        setIsPaymentDone(true);
      }
    }
  }, [request]);

  return (
    <div data-testid="cmp-issuanceuniversityprogressview">
      <ContainerProcedure>
        <Processing isOpen={false} />
        <ButtonBack onClick={handlerBackButton} />
        {isLoading && <Spinner />}
        {!isLoading && procedure && (
          <SubContainer>
            <ToggleHeader
              name={procedure?.name}
              amount={procedure?.amount}
              duration={procedure?.duration}
              date={procedure?.endDate}
              status={request?.status}
              childContent={
                <ProcedureInfoComponent
                  deliverySchedule={procedure?.deliverySchedule}
                />
              }
              twoLineFormat
              inRegister
            />
            <TextTitle title="Progreso" />
            <Block customized padding="28px 0px 45px 8px">
              <Step
                name={procedure?.steps[0]?.name}
                order={procedure?.steps[0]?.order}
                isComplete
              >
                <p>Resumen</p>
                <li>Contacto: {phone}</li>
                <li>Campus: {campus}</li>
              </Step>
              <Step
                name={procedure?.steps[1]?.name}
                order={procedure?.steps[1]?.order}
                isComplete={isPaymentDone}
                disabled={evalStatus()?.name === 'ANULADO'}
              >
                <>
                  {evalStatus()?.name === 'CREADO' && (
                    <CardPayment
                      title="Genera el cargo de tu trámite activando tu pago"
                      infoText="Recuerda que una vez realizado el pago, se procederá con los demás pasos."
                      buttonText="Activar"
                      isPaymentActive={isPaymentActive}
                      isPaymentDone={isPaymentDone}
                      handlerActivatePayment={handlerActivatePayment}
                      isLoadingActivatePayment={isLoadingActivatePayment}
                      isSuccessActivatePayment={isSuccessActivatePayment}
                      firstDialogSubtitle={`Al aceptar, se cargará el monto de <b>S/ ${procedure?.amount}.00</b/> a tus pagos pendientes.`}
                      secondDialogSubtitle={
                        'Ya se encuentra disponible tu pago. Recuerda que una vez realizado el pago podrás recoger tu carné universitario.'
                      }
                    />
                  )}
                  {evalStatus()?.name === 'PAGO_ACTIVADO' && !isPaymentDone && (
                    <CardPayment
                      title="El pago ha sido activado"
                      infoText="Recuerda que una vez realizado el pago, se procederá con los demás pasos."
                      buttonText="Ir a pagos"
                      // paymentAmount={175}
                      isPaymentActive={isPaymentActive}
                      isPaymentDone={false}
                      handlerActivatePayment={handlerActivatePayment}
                      isLoadingActivatePayment={isLoadingActivatePayment}
                      isSuccessActivatePayment={isSuccessActivatePayment}
                      showActivatedPaymentModal={showActivatedPaymentModal}
                      setShowActivatedPaymentModal={
                        setShowActivatedPaymentModal
                      }
                      isIssuanceUniversityCard
                    />
                  )}
                </>
                {isPaymentDone && <>{procedure?.steps[2]?.date}</>}
              </Step>
              <Step
                name={procedure?.steps[2]?.name}
                order={procedure?.steps[2]?.order}
                isComplete={evalStatus()?.isComplete}
                isLast
              >
                {evalStatus()?.name === 'PROCEDE' && (
                  <CardProgress
                    image={[documentSuccessImage, documentSuccessDskImage]}
                    title={`Finalizado`}
                  >
                    <div style={{ textAlign: 'left' }}>
                      <p>
                        Se te enviará un mensaje a tu correo institucional
                        indicando la fecha de entrega de tu carné.
                      </p>
                      <br />
                      <p>
                        <h4>Fecha de entrega de carné: </h4>
                      </p>
                      <p>
                        La fecha aproximada de entrega se establece según la
                        fecha del pago de tu solicitud. Mira el{' '}
                        <Link
                          linkType="external"
                          url="https://info.utp.edu.pe/articulo/KA-01805"
                          linkName="cronograma de entregas."
                        />
                      </p>
                    </div>
                  </CardProgress>
                )}
                {evalStatus()?.name === 'ANULADO' && (
                  <>
                    {procedure?.steps[2]?.date && (
                      <div style={{ paddingBottom: '8px' }}>
                        {procedure?.steps[2]?.date}
                      </div>
                    )}
                    <CardProgress
                      image={[documentFailedImage, documentFailedDskImage]}
                      title={`Tu solicitud se ha anulado`}
                      subtitle="No pagaste a tiempo el monto de tu trámite."
                    />
                  </>
                )}
              </Step>
            </Block>
            {evalStatus()?.name !== 'ANULADO' &&
              evalStatus()?.name !== 'PROCEDE' &&
              evalStatus()?.name !== 'NO_PROCEDE' && (
                <ButtonCancelRequest handlerShowAnulate={handlerShowAnulate} />
              )}
          </SubContainer>
        )}
        <ModalConfirmation
          show={showAnulate && !isLoadingCancel}
          handleClose={handlerCloseModal}
        >
          <ConfirmAction
            activatePayment={false}
            gotoPayment={false}
            anulate
            handleClickConfirm={handlerOkModalProgress}
            handleClickCancel={handlerCloseModal}
            amount={procedure?.amount}
            deliveryMode={deliveryMode || ''}
            amountDelivery={amountDelivery || 0}
          />
        </ModalConfirmation>
      </ContainerProcedure>
    </div>
  );
};

export default IssuanceUniversityCardProgressView;
